"use client";

// Re-export the client card component with the proper suffix
export { default } from "./SpotlightCard.client";